import { useGetSettings } from "../apis/typo3/useGetSettings";
import { usePersistBoundStore } from "../zustand/Store";

export const useUpdateUserSettings = () => {
    const updateOfflineDuration = usePersistBoundStore.getState().updateOfflineDuration;
    const updateFavouriteEdition = usePersistBoundStore.getState().updateFavouriteEdition;
    const updateNotificationSettings = usePersistBoundStore.getState().updateNotificationSettings;
    const { getSettings } = useGetSettings();

    const updateUserSettings = async (jwt: string) => {
        const userSettings = await getSettings(jwt);
        //console.log("useUpdateUserSettings - userSettings: ", userSettings)
        if (userSettings.ok) {
            //console.log("useHanldeLogin - userSettings:", userSettings);
            updateNotificationSettings(userSettings.notificationSettings);
            updateFavouriteEdition(userSettings.favouriteEdition);
            updateOfflineDuration(userSettings.offlineDuration);
        } else {
            console.warn("useUpdateUserSettings - userSettings failed")
        }
    }
    return { updateUserSettings }
}